import React from 'react'
import './touch.scss'

const GetInTouch = () => {
  return (
    <div className='container'>
        <div className="form_wrapper">
            <h1>LET'S GET IN TOUCH</h1>
            <div className="contact_form">
                <form>
                    <div className="subject_input input_control">
                        <input type="text" placeholder='Subject' />
                        <input type="text" placeholder='Your email' />
                    </div>
                    <div className="input_control">
                        <textarea type="text" placeholder='How can we help you?' />
                    </div>
                    <div className="input_control">
                        <span>What is you budget for this project</span>
                        <select>
                            <option value="less then $5000" selected>less then $5000</option>
                            <option value="$5000 - $10,000">$5000 - $10,000</option>
                            <option value="$10,000 - $20,000">$10,000 - $20,000</option>
                            <option value="$20,000 - $40,000">$20,000 - $40,000</option>
                            <option value="$40,000+">$40,000+</option>
                        </select>
                    </div>
                </form>
            </div>
        </div>
    </div>
  )
}

export default GetInTouch